module.exports = __webpack_public_path__ + "static/strategy-d015fa277d2508bc29b3613fb2279723.jpg";